import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './i18n';
import { initializeModularPlugins } from './utils/ModularPluginInitializer';

// React 18 root API
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

// ✅ ÉTAPE 1 : Exécuter l'initialisation de VOS 9 plugins
initializeModularPlugins();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
